import { requests } from "../../../api/agent"

export default {
	create                : (params) => requests.post('/ReStandardsDeterminants/create', params),
	update                : (params) => requests.post('/ReStandardsDeterminants/update', params),
	delete                : (params) => requests.getWithParams('/ReStandardsDeterminants/delete', params),
	restore               : (params) => requests.getWithParams('/ReStandardsDeterminants/restore', params),
	getPaged              : (params) => requests.getWithParams('/ReStandardsDeterminants/getPaged', params),
    getPagedAll           : (params) => requests.getWithParams('/ReStandardsDeterminants/getPagedAll', params),
	getPagedAudit         : (params) => requests.getWithParams('/ReStandardsDeterminants/getPagedAudit', params)
}